import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'

export const requests = {
  extends: 'AppPage',
  metadata: { title: 'Requests / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  RequestsMain: {},
  TicketsDetailModal: {}
}

export const requestsInbound = {
  extends: 'AppPage',
  metadata: { title: 'Inbound requests / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  RequestsInboundMain: {},
  TicketsDetailModal: {}
}

export const requestsOutbound = {
  extends: 'AppPage',
  metadata: { title: 'Outbound requests / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  RequestsOutboundMain: {},
  TicketsDetailModal: {}
}

export const requestsAudit = {
  extends: 'AppPage',
  metadata: { title: 'Requests audit / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  RequestsAuditMain: {},
  TicketsDetailModal: {}
}
